import { noop } from 'lodash';
import { Router } from 'vue-router';
import { AuthorizationError } from '@/shared/utils/errors';
import i18n from '../../i18n';
import Modals from '../../services/Modals';

export default function setupErrorHandler(router: Router): void {
  router.onError(error => {
    if (error instanceof AuthorizationError) {
      Modals.error(i18n.global.t('general.noPermission'));
      router.push('/').catch(noop);
    } else {
      // eslint-disable-next-line no-console
      console.warn(error.reason || error);
    }
  });
}
